import { render, staticRenderFns } from "./Movie.vue?vue&type=template&id=c0307d56&"
import script from "../../models/communication/movie.ts?vue&type=script&lang=ts&"
export * from "../../models/communication/movie.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports